// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage, deleteToken } from "firebase/messaging";
import api from "./servicos/Api";

const firebaseConfig = {
    apiKey: "AIzaSyCWwH1SR4jYTra-0OipVKQesbKraJ3cquA",
    authDomain: "appconselho.firebaseapp.com",
    databaseURL: "https://appconselho.firebaseio.com",
    projectId: "appconselho",
    storageBucket: "appconselho.appspot.com",
    messagingSenderId: "297633110865",
    appId: "1:297633110865:web:a488792f0f6531c0585170",
    measurementId: "G-J72VZJM97H"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);
const analytics = getAnalytics(firebaseApp);

export const fetchToken = (setTokenFound) => {
    console.log('fetchToken');
    navigator.serviceWorker
    .register("./firebase-messaging-sw.js")
    .then(function(registration) {
        console.log('registration done');
        getToken(
            messaging, 
            { 
                vapidKey: 'BPDhWCzAdmyZj9HEqi3BOTmN99YhJs1iPq7FPj-DxXlK17ruiEh7_GDQKvr8_660uO31a5p_biYlzGgF4X40nDI',
                serviceWorkerRegistration : registration 
            }
        ).then((currentToken) => {
            console.log('then token '+currentToken);
            if (currentToken) {
                console.log('dt token before');
                if(localStorage.getItem('dt')){
                    console.log('dt token');
                    salvaToken(currentToken);
                    localStorage.setItem('ft', currentToken);
                }
            } else {
                console.log('No registration token available. Request permission to generate one.');

            }
        }).catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
        }); 
    }).catch(function(err) {
        console.log("Service worker registration failed, error:"  , err );
    });   
}

export const salvaToken = (firebase_token) => {
    api.post(
        '/login_app/set_firebase_token', 
        {firebase_token: firebase_token, device_token: localStorage.getItem('dt')}
    );
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
});

export const onLogout = () => {
    deleteToken(messaging).then(() => {
        console.log('Token removido com sucesso!');
      }).catch((error) => {
        console.log('Erro ao remover o token:', error);
      });
};